"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.gameStatusQuery = graphql_tag_1.default("query gameStatus {\n  gameStatus {\n    hasActiveRace\n    lobbyId\n    lobbyAccepted\n    lastRace {\n      averageSpeed\n      correctAnswersCount\n      time\n      lobbyId\n    }\n    isDayRideable\n    racesCountAvailable\n    racesCountThisDay\n  }\n}");
